export const CANCEL_MANAGE_COMPANY_EDIT_STATE = "cancelManageCompanyEditState";
export const FETCH_ECS_COMPANY = "fetchEcsCompany";
export const FETCH_ECS_COMPANY_LIST = "fetchEcsCompanies";
export const SAVE_MANAGE_COMPANY = "updateEcsCompanyDetails";
export const SAVE_EDITED_ECS_COMPANY = "SAVE_EDITED_ECS_COMPANY";
export const DELETE_ECS_COMPANY = "DELETE_ECS_COMPANY";
export const SAVE_NEW_ECS_COMPANY = "SAVE_NEW_ECS_COMPANY";
